<adapt-collapsible-search-row #row
                              [result]="result"
                              [matches]="matches"
                              [href$]="href$"
                              [crumbTemplate]="crumbs"
                              [snippetTemplate]="snippet">
    <div class="d-flex flex-grow-1 align-items-center justify-content-between">
        <div class="d-flex flex-grow-0 me-2">
            <div class="d-flex align-items-center result-icon system-icon">
                <i class="fal fa-solar-system fa-inverse"></i>
            </div>
        </div>

        <div class="flex-grow-1 text-break d-flex align-items-center">
            <adapt-highlighted-text [needle]="keyword"
                                    [haystack]="result.name"></adapt-highlighted-text>
            <adapt-display-labels class="ms-2"
                                  [linkDisabled]="true"
                                  [labelLocations]="labelLocations"></adapt-display-labels>
        </div>
    </div>
</adapt-collapsible-search-row>

<ng-template #snippet
             let-match="match">
    <!-- custom styling for key result previews -->
    <!-- can't just use @if as the match context needs to be passed to the default template -->
    <ng-container *ngTemplateOutlet="isProcessStep(match) ? processStepTemplate : row.defaultSnippetTemplate; context: { match: match }">
    </ng-container>
</ng-template>

<ng-template #processStepTemplate
             let-matched="match">
    @if (asProcessStep(matched); as match) {
        <div class="flex-basis-100 d-flex align-items-center">
            @if (getStepLabelLocations(match.extra?.labelLocationIds ?? []); as locations) {
                <adapt-display-labels class="ms-2"
                                      [linkDisabled]="true"
                                      [labelLocations]="locations"></adapt-display-labels>
            }
            <div class="d-inline-block"
                 [ngClass]="getStepClass(match.extra?.stepType ?? ProcessStepType.ProcessStep) + '-bg'">
                <adapt-highlighted-text [needle]="keyword"
                                        [haystack]="match.snippet"></adapt-highlighted-text>
                <i class="ms-1"
                   [ngClass]="getStepIconClass(match.extra?.stepType ?? ProcessStepType.ProcessStep)"></i>
            </div>
        </div>
    }
</ng-template>

<ng-template #crumbs
             let-matched="match">
    @if (asMatch(matched); as match) {
        @for (crumb of match.field; track crumb; let last = $last; let i = $index) {
            <!-- i >= 2 means we're within the process map -->
            @if (isProcessStep(match) && i >= 2) {
                <div class="process-step-bg d-inline-block">
                    {{ crumb }}
                    <i class="ms-1"
                       [ngClass]="getStepIconClass(match.extra?.stepType ?? ProcessStepType.ProcessStep)"></i>
                </div>
            } @else {
                <span>{{ crumb }}</span>
            }
            @if (!last) {
                <span class="px-1">&gt;</span>
            }
        }
    }
</ng-template>
